<template>
  <div class="seomain">
    <st-header
      title="确认收款"
      :back-able="true"
    >
    </st-header>
    <div class="st-form-content">
      <st-form ref="form">
        <!-- <div class="st-form-title">基本信息</div> -->
        <div class="st-form-group">

          <van-cell-group inset>
						<st-form-item key="code" label="收款单号" prop="code" :required="true" disabled>
						  <van-field
						    class="st-form-item-input"
						    v-model="formData.code"
						    name="收款单号"
						    label=""
						    placeholder="请填写收款单号"
						  />
						</st-form-item>
						
						<st-form-item key="type" label="收款方式" prop="type">
						  <st-select
						    v-model="formData.type"
								:defText="formData.type_text"
						    name="收款方式"
						    placeholder="请选择收款方式"
						    :options="$option['getModelConf']('incomeorder','type')"
								:filterable="false"
								:clearable="true"
						  >
						  </st-select>
						</st-form-item>
						
						<st-form-item key="corporation_id" label="收款账户" prop="corporation_id">
						  <st-select
						    v-model="formData.corporation_id"
								:defText="formData.corporation_name"
						    name="收款账户"
						    placeholder="请选择收款账户"
								:customParams="{'company_id': formData.company_id}"
						    :options="$option['getCorporation']"
						  >
						  </st-select>
						</st-form-item>
						
						<st-form-item key="receive_price" label="已收金额" prop="receive_price" :required="true">
						  <van-field
						    class="st-form-item-input"
						    v-model="formData.receive_price"
						    name="已收金额"
						    label=""
						    placeholder="请填写已收金额"
								disabled
						  />
						</st-form-item>
						
						<st-form-item key="amount" label="收款金额" prop="amount" :required="true">
						  <van-field
						    class="st-form-item-input"
						    v-model="formData.amount"
						    name="收款金额"
						    label=""
						    placeholder="请填写收款金额"
						  />
						</st-form-item>

						<st-form-item key="currency" label="币种" prop="currency" :required="true">
						  <st-select
						    v-model="formData.currency"
						    name="币种"
						    placeholder="请选择币种"
						    :options="$option['getCurrency']"
						  >
						  </st-select>
						</st-form-item>
						

            <st-form-item key="remark" label="备注" prop="remark">
							<van-field
								class="st-form-item-input"
								v-model="formData.remark"
								name="备注"
								label=""
								placeholder="请填写备注"
							/>
            </st-form-item>
						
						<st-form-item key="certificate_images" label="收款凭证" prop="certificate_images">
						  <st-file-upload
						    v-model="formData['certificate_images']"
						  >
						  </st-file-upload>
						</st-form-item>
						
						<st-form-item key="invoice_images" label="发票" prop="invoice_images">
						  <st-file-upload
						    v-model="formData['invoice_images']"
						  >
						  </st-file-upload>
						</st-form-item>
						
          </van-cell-group>
        </div>
        
        <div style="margin: 16px;" class="form-submit-button">
          <van-button round block type="primary"  @click="onSubmit">
            提交
          </van-button>
        </div>
      </st-form>
    </div>
    
  </div>
</template>

<script>
import StFileUpload from "@/components/FileUpload.vue";
import StSelect from "@/components/Select.vue";
import StDate from "@/components/Date.vue";
import StHeader from "@/components/layout/Header.vue";
import StForm from "@/components/form.vue";
import StFormItem from "@/components/formItem.vue";
import formConf from "./conf/form.js";

export default {
  name: 'stSalesAdd',
  components: {
    'st-file-upload': StFileUpload,
    'st-select': StSelect,
    "st-header": StHeader,
    "st-form-item": StFormItem,
		StForm,
		StDate
  },
  props: {},
  data() {
    return {
      formRule: {},
      formData: {
				currency: 'CNY',
				exchange_rate: 1,
				amount: 0,
				"certificate_images": [],
				"invoice_images": [],
      }, 
      loading: false,
      actField: '',
      actOptions: [],
			conf: formConf,
    };
  },
  watch: {},
	computed: {},
  created() {
    this.init();
    window.h5sdk && window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "确认收款" });
    });
  },
  mounted() {},

  methods: {
    init() {
			let id = parseInt(this.$route.params['id']);
			this.formData.id = isNaN(id) ? 0 : id;
			if (!this.formData.id) {
				window.history.go(-1);
				return;
			} 
			this.getUpdateData();
		},
		// 获取编辑需要显示的数据
		getUpdateData() {
			if (this.formData.id) {
				this.$post(`${this.$api.stIncomeOrderEditInfo}`, {id: this.formData.id}).then((res) => {
					let data = res.data;
					data.certificate_images = [];
					data.invoice_images = [];
					this.formData = data;
				}).catch((err) => {
					window.history.go(-1);
					console.log('incomeorder/edit', err);
				});
			} else {
				this.$post(`${this.$api.stIncomeOrderGeneCode}`, {}).then((res) => {
					this.$set(this.formData, ['code'], res.data)
				});
			}
		},

    // 提交表单
    onSubmit() {
     this.$refs.form.validater.valid((isValid, lastError) => {
        if (!isValid) {
          this.$toast.fail('表单异常：' + lastError);
        }
      });
			
      let formData = JSON.parse(JSON.stringify(this.formData));
			formData['certificate_images'] = formData['certificate_images'].map((item) => { return item.url; }).join(',');
			formData['invoice_images'] = formData['invoice_images'].map((item) => { return item.url; }).join(',');
			if (this.formData.id) {
				this.pay(formData);
			} else {
				this.$toast.fail('提交异常，请稍后重试');
				window.history.go(-1);
			}
      
    },
		
		pay(formData) {
			this.$post(this.$api.stIncomeOrderPay, formData).then((res) => {
			  if (res.code !== 1) {
			    this.$toast.fail(res.msg ? res.msg : '收款异常');
			  } else {
			    this.$toast.success("收款成功");
			    this.$router.replace(`/incomeorder/list`);
			  }
			});
		},
  },
};
</script>

<style lang="scss" scoped>
.st-form-content {
  margin: 20px 15px;
	form {
		overflow: hidden;
	}
	
  .st-form-title {
    border-radius: 5px 5px 0px 0px;
    padding: 20px 21px;
    font-size: 20px;
    background-color: rgb(207, 212, 217);

    .st-van-btn-info {
      float: right;
    }
  }
  .st-form-group {
    background-color: white;
    margin-bottom: 20px;
    position: relative;
    overflow: hidden;
		padding-bottom: 16px;
		border-radius: 5px;
    
    .st-van-filed-label-imp {
      color: rgb(231, 91, 124);
    }

    .st-van-filed-label {
      margin: 15px 6px 8px; 
    }
    
    .van-field {
      box-shadow: inset 0 0 0 2px rgb(223,223,223);
      border-radius: 5px;
    }

    .form-submit-button {
      margin-top: 12px;
    }

  }

}

</style>
